export const CANCEL_EVENT_CODE = 'ERR_CANCELED';

// Use this function if you want to abort previous action with same key if it's not finished.
// Read more about it:
export const withAbortingDuplicates = function (key, cb) {
  const controller = new AbortController();
  const signal = controller.signal;

  // Create abort controllers store.
  if (!window.abortControllers) {
    window.abortControllers = {}
  }

  // Abort previous action with same key.
  window.abortControllers[key]?.abort();

  // Save controller in store to make possible abort it if needed.
  window.abortControllers[key] = controller;

  return cb(signal)
}

export const isEventCanceled = function (e) {
  return e.code === CANCEL_EVENT_CODE
}
